import { AppState } from "react-native";
import { addBreadcrumb } from "@utils/sentry";
import { captureException } from "@utils/captureException";

type AudioEventContext = {
  trackId?: string | null;
  positionMs?: number | null;
  durationMs?: number | null;
  bufferedPositionMs?: number | null;
  appState?: string | null;
  [key: string]: unknown;
};

const AUDIO_AREA = "media";
const NETWORK_RETRY_MESSAGE_PATTERN = /^Network retry \d+\/\d+:/;

export function addAudioBreadcrumb(
  operation: string,
  data?: AudioEventContext,
  level: "info" | "warning" | "error" = "info",
) {
  addBreadcrumb({
    category: AUDIO_AREA,
    message: operation,
    level,
    data: {
      appState: AppState.currentState ?? "unknown",
      ...data,
    },
  });
}

export function captureAudioPlaybackError(
  operation: string,
  message: string,
  data?: AudioEventContext,
) {
  captureException(new Error(message), {
    channel:
      operation === "rnap.playback_error" &&
      data?.severity === "transient" &&
      NETWORK_RETRY_MESSAGE_PATTERN.test(message)
        ? "warning"
        : "error",
    area: AUDIO_AREA,
    operation,
    tags: {
      player: "rnap",
      trackId: data?.trackId ? String(data.trackId) : "unknown",
    },
    extra: {
      appState: AppState.currentState ?? "unknown",
      ...data,
    },
  });
}
